"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Locale = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
require('../../utilities/globalize');
var Locale = exports.Locale = function locale($window, TzInfoName) {
  var Globalize = $window.Globalize;
  function convertDateToUserTz(input, shouldConvertTz) {
    if (!input || !(0, _momentTimezone["default"])(input).isValid()) {
      return input;
    }
    if (!shouldConvertTz) {
      return (0, _momentTimezone["default"])(input).toDate();
    }
    var dateTimeConverted = _momentTimezone["default"].utc(input).tz(TzInfoName);
    var dateParts = ['year', 'month', 'date', 'hour', 'minute', 'second'].map(function (part) {
      return dateTimeConverted.get(part);
    });
    return _construct(Date, _toConsumableArray(dateParts));
  }
  function formatDate(input, formatString) {
    var dateInput = typeof input === 'string' ? input.split('T')[0] : input;
    var dateObj = convertDateToUserTz(dateInput);
    return Globalize.format(dateObj, formatString || 'd');
  }
  return {
    set: function setLocale(culture) {
      Globalize.culture(culture);
    },
    get: function getLocale() {
      return Globalize.culture();
    },
    parseDate: function parseDate(text) {
      var localDate = Globalize.parseDate(text);
      if (!localDate) {
        localDate = Globalize.parseDate(text, null, 'en');
        if (!localDate) {
          localDate = Globalize.parseDate(text, 'yyyy-MM-dd');
        }
      }
      return localDate;
    },
    parseDateLocaleFormat: function parseDateLocaleFormat(text) {
      var singleDigitFormat = Globalize.culture().calendar.patterns.d.replace(/d(?=d)|M(?=M)/g, '');
      var localDate = Globalize.parseDate(text, singleDigitFormat);
      return localDate;
    },
    parseDateString: function parseDateString(value) {
      var date;
      if (typeof value === 'string') {
        if (value.indexOf('/Date(') !== -1) {
          date = new Date(parseInt(value.substr(6), 10));
        }
      }
      return date;
    },
    /**
     * Format a date as a string. Will default to Globalize's "short date" for the given culture if no formatString is specified.
     * @param date
     * @param formatString
     * @returns {string} - formatted date
     */
    formatDate: formatDate,
    formatDateTime: function formatDateTime(input) {
      var shouldConvertTz = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var date = convertDateToUserTz(input, shouldConvertTz);
      return "".concat(Globalize.format(date, 'd'), " ").concat(Globalize.format(date, 't'));
    },
    getDateFormat: function getDateFormat() {
      return Globalize.culture().calendar.patterns.d;
    },
    getLocaleMoment: function getLocaleMoment(dateInput) {
      var shouldConvertTz = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return shouldConvertTz ? _momentTimezone["default"].utc(dateInput).tz(TzInfoName) : (0, _momentTimezone["default"])(dateInput);
    },
    parseCurrency: function parseCurrency(text) {
      var value = Globalize.parseFloat(text);
      if (isNaN(value)) {
        return null;
      }
      return value;
    },
    formatCurrency: function formatCurrency(number, precision, culture) {
      return Globalize.format(number, "c".concat(precision || ''), culture);
    },
    formatISO: function formatISO(date) {
      return formatDate(date, 'yyyy-MM-dd');
    },
    formatNumber: function formatNumber(NUMBER, DECIMALS, removeTrailingZeros, padZero) {
      var number = NUMBER,
        decimalPlaces = DECIMALS,
        integerPartLength;
      if (padZero) {
        return Globalize.format(number, padZero);
      }
      if (!isNaN(number)) {
        number = Number(number);
        if (removeTrailingZeros) {
          integerPartLength = Math.floor(number).toString().length + 1;
          decimalPlaces = Math.max(0, Math.min(decimalPlaces, number.toString().length - integerPartLength));
        }
        return Globalize.format(number, "N".concat(decimalPlaces));
      } else {
        return number;
      }
    },
    formatPercentage: function formatPercentage(NUMBER, DECIMALS, removeTrailingZeros, firstDivideBy100) {
      var number = NUMBER,
        decimalPlaces = DECIMALS,
        integerPartLength;
      if (!isNaN(number)) {
        number = Number(number);
        if (removeTrailingZeros) {
          integerPartLength = Math.floor(number).toString().length + 1;
          decimalPlaces = Math.max(0, Math.min(decimalPlaces, number.toString().length - integerPartLength));
        }
        if (firstDivideBy100) {
          number /= 100;
        }
        return Globalize.format(number, "P".concat(decimalPlaces));
      } else {
        return number;
      }
    },
    getCurrencySymbol: function getCurrencySymbol() {
      return Globalize.culture().numberFormat.currency.symbol;
    }
  };
};
Locale.$inject = ['$window', 'TzInfoName'];